import { CanActivateFn } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { GetParams } from '@app/shared';
import { PartnerService } from '../services/partner.service';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

export const authGuard: CanActivateFn = (route, state) => {
  const oidcService = inject(OidcSecurityService);
  const partnerService = inject(PartnerService);
  const authService = inject(AuthService);

  return oidcService.checkAuth(undefined, `0-${environment.clientId}`).pipe(
    switchMap(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        return of(false);
      }

      return oidcService.getUserData().pipe(
        switchMap((userData) => {
          const params: GetParams = {
            startRow: 0,
            endRow: 1,
            sortProperty: 'id',
            sortDirection: 'asc',
            filterProperty: 'email',
            filterValue: userData.email,
          };

          return partnerService.getUser(params).pipe(
            map((rsp) => {
              authService.loggedUser = rsp.data.rows[0];
              return true;
            }),
            catchError((error) => {
              console.error(error);
              authService.loggedUser = undefined;
              return of(true); // Aún permitimos el acceso aunque falle la carga de datos
            })
          );
        })
      );
    })
  );
};
